"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _reselect = require("reselect");

var _dualListControlled = _interopRequireDefault(require("../dual-list-controlled"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getPois = function getPois(state) {
  return state.informationLists.pois;
};

var getPoiCategories = function getPoiCategories(state) {
  return state.informationLists.poiCategories;
};

var poiSelector = (0, _reselect.createSelector)(getPois, function (pois) {
  return pois.map(function (_ref) {
    var id = _ref.id,
        name = _ref.name,
        category = _ref.category;
    return {
      id: id,
      label: name,
      category: category
    };
  });
});
var poiCategorySelector = (0, _reselect.createSelector)(getPoiCategories, function (categories) {
  return categories.map(function (_ref2) {
    var id = _ref2.id,
        name = _ref2.name;
    return {
      id: id,
      label: name
    };
  });
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    pois: poiSelector(state),
    poiCategories: poiCategorySelector(state)
  };
};

var PoiSelectionDualLists = function PoiSelectionDualLists(_ref3) {
  var allSelected = _ref3.allSelected,
      pois = _ref3.pois,
      poiCategories = _ref3.poiCategories,
      selectedPois = _ref3.selectedPois,
      selectedPoiCategories = _ref3.selectedPoiCategories,
      onChange = _ref3.onChange,
      hideServiceStations = _ref3.hideServiceStations;

  var selectPois = function selectPois(items) {
    return onChange({
      selectedPois: items.map(function (item) {
        return item.id;
      }),
      selectedPoiCategories: selectedPoiCategories,
      allSelected: allSelected
    });
  };

  var selectPoiCategories = function selectPoiCategories(items) {
    return onChange({
      selectedPois: selectedPois,
      selectedPoiCategories: items.map(function (item) {
        return item.id;
      }),
      allSelected: allSelected
    });
  };

  var deselectPois = function deselectPois(items) {
    var deselectedIds = items.map(function (item) {
      return item.id;
    });
    var filteredItems = selectedPois.filter(function (id) {
      return !deselectedIds.includes(id);
    });
    onChange({
      selectedPois: filteredItems,
      selectedPoiCategories: selectedPoiCategories,
      allSelected: allSelected
    });
  };

  var deselectPoiCategories = function deselectPoiCategories(items) {
    var deselectedIds = items.map(function (item) {
      return item.id;
    });
    var filteredItems = selectedPoiCategories.filter(function (id) {
      return !deselectedIds.includes(id);
    });
    onChange({
      selectedPois: selectedPois,
      selectedPoiCategories: filteredItems,
      allSelected: allSelected
    });
  };

  var selectablePois = (0, _react.useMemo)(function () {
    if (hideServiceStations) {
      return pois.filter(function (poi) {
        var _poi$category, _poi$category2, _poi$category3, _poi$category4;

        return ((_poi$category = poi.category) === null || _poi$category === void 0 ? void 0 : _poi$category.icon) !== 'schmitz' && ((_poi$category2 = poi.category) === null || _poi$category2 === void 0 ? void 0 : _poi$category2.icon) !== 'carrier' && ((_poi$category3 = poi.category) === null || _poi$category3 === void 0 ? void 0 : _poi$category3.icon) !== 'thermoking' && ((_poi$category4 = poi.category) === null || _poi$category4 === void 0 ? void 0 : _poi$category4.icon) !== 'railWorkshop';
      });
    }

    return pois;
  }, [hideServiceStations, pois]);
  return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.POIWithText, null),
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "duallist.poiSelection",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "dual-list-individually-selectable"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "selected-assets"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "individual-selection-buttons-container"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    className: (0, _classnames["default"])('action-button', 'inactive-color-button', {
      'individual-color-button': allSelected
    }),
    onClick: function onClick() {
      return onChange({
        selectedPois: selectedPois,
        selectedPoiCategories: selectedPoiCategories,
        allSelected: true
      });
    },
    key: "allButton"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "common.all",
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    className: (0, _classnames["default"])('action-button', 'inactive-color-button', {
      'individual-color-button': !allSelected
    }),
    raised: !allSelected,
    onClick: function onClick() {
      return onChange({
        selectedPois: selectedPois,
        selectedPoiCategories: selectedPoiCategories,
        allSelected: false
      });
    },
    key: "individualButton"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "common.selectIndividually",
    tagName: "span"
  }))), !allSelected && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mt-3 mb-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.POIWithText, {
    className: "w-4 h-4 mr-1"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "duallist.poiCategories"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold text-blue-500"
    }, message);
  })), /*#__PURE__*/_react["default"].createElement(_dualListControlled["default"], {
    selectableItems: poiCategories.filter(function (category) {
      return !selectedPoiCategories.includes(category.id);
    }),
    selectedItems: poiCategories.filter(function (category) {
      return selectedPoiCategories.includes(category.id);
    }),
    onSelectAll: selectPoiCategories,
    onSelect: selectPoiCategories,
    onDeselectAll: deselectPoiCategories,
    onDeselect: deselectPoiCategories,
    assignedItemsText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.assigned",
      tagName: "span"
    }),
    notAssignedItemsText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.notAssigned",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mt-3 mb-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.POIWithText, {
    className: "w-4 h-4 mr-1"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "duallist.pois"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold text-blue-500"
    }, message);
  })), /*#__PURE__*/_react["default"].createElement(_dualListControlled["default"], {
    selectableItems: selectablePois.filter(function (poi) {
      return !selectedPois.includes(poi.id);
    }),
    selectedItems: selectablePois.filter(function (poi) {
      return selectedPois.includes(poi.id);
    }),
    onSelectAll: selectPois,
    onSelect: selectPois,
    onDeselectAll: deselectPois,
    onDeselect: deselectPois,
    assignedItemsText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.assigned",
      tagName: "span"
    }),
    notAssignedItemsText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.notAssigned",
      tagName: "span"
    })
  })))));
};

PoiSelectionDualLists.propTypes = {
  allSelected: _propTypes["default"].bool,
  pois: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  poiCategories: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  selectedPois: _propTypes["default"].arrayOf(_propTypes["default"].number),
  selectedPoiCategories: _propTypes["default"].arrayOf(_propTypes["default"].number),
  onChange: _propTypes["default"].func,
  hideServiceStations: _propTypes["default"].bool
};
PoiSelectionDualLists.defaultProps = {
  allSelected: true,
  pois: [],
  poiCategories: [],
  selectedPois: [],
  selectedPoiCategories: [],
  onChange: function onChange() {},
  hideServiceStations: false
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(PoiSelectionDualLists);

exports["default"] = _default;